export default __webpack_public_path__ + "static/caruosel-bottom-mobile-60d8b022253fb8cfc6382b060fcd330e.jpg";